import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type IButtonGroupSeparatorProps from "./type";
import stylesheet, {
    getButtonGroupSeparatorColor,
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useAttachedGroupItem
} from "../../../attachedGroup/context";

const ButtonGroupSeparator: FC<IButtonGroupSeparatorProps> = ({
    customTheme,
    style,
    ...props
}) => {
    const {
        borders,
        colors
    } = NCoreUIKitTheme.useContext(customTheme);

    const groupItem = useAttachedGroupItem();

    const variant = groupItem?.groupVariant ?? "tonal";

    const {
        container: containerDynamicStyle
    } = useStyles({
        orientation: groupItem?.orientation ?? "horizontal",
        color: getButtonGroupSeparatorColor({
            type: groupItem?.type ?? "neutral",
            variant,
            colors
        }),
        borders
    });

    if(variant === "outline") {
        return null;
    }

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
        aria-hidden={true}
    />;
};
export default ButtonGroupSeparator;
